import { allPhotosCollectedByRootImage } from './collect-by-root-image';
import SizeHelpers from './size-helpers';

function photosById({ photoIds, sizes, id }) {
  if (Object.keys(photoIds).length) {
    return photoIds[id];
  }
  const photos = allPhotosCollectedByRootImage(sizes);

  Object.entries(photos).forEach(([id, size]) => {
    photoIds[id] = Object.entries(size).map(([, [photo]]) => photo.id);
  });

  return photoIds[id];
}

function getSizesByFinish({ sizes, finish }) {
  return sizes.filter((size) => size.key.includes(finish.name));
}

function sortedAndFilteredImages({ viewingSizeKey, sizes, finish, photoIds }) {
  const photosCollection = allPhotosCollectedByRootImage(
    getSizesByFinish({ sizes, finish })
      .filter(SizeHelpers.sizeHasPrints)
      .map(SizeHelpers.stripZeroQuantityPhotosFromSize),
  );

  return Object.entries(photosCollection)
    .map(([id, photoSizes = {}]) => {
      let photos = Object.values(photoSizes).flat();

      const isLastPhoto = photos.length === 1;

      if (viewingSizeKey) {
        photos = photos.filter((p) => p.size.key === viewingSizeKey);
      }

      photos = photos.sort((a, b) => {
        const idArray = photosById({ photoIds, sizes, id }) || [];

        const aIndex = idArray.indexOf(a.id);
        if (aIndex < 0) {
          return 1;
        }

        const bIndex = idArray.indexOf(b.id);
        if (bIndex < 0) {
          return -1;
        }

        // Sort in order of ID Array
        return aIndex < bIndex ? -1 : 1;
      });

      return {
        id,
        photos,
        isLastPhoto,
      };
    })
    .filter(({ photos }) => photos.length)
    .sort((a, b) => Number(b.id) - Number(a.id));
}

export { sortedAndFilteredImages };
